import React from "react";
import { useParams } from "react-router-dom";
import CollectionCategoryPurchase from "./Collection/CollectionCategoryPurchase";
import SubCategoryPurchase from "./Category/SubCategoryPurchase";
import SetPurchaseDesignPage from "./Sets/Product/SetPurchaseDesignPage";
import { PartialSetsPurchaseDesignPage } from "./Partial Sets/Product/PartialSetsPurchaseDesignPage";
import CategoryDesignPurchasePage from "./Category/ProductPage/CategoryDesignPurchasePage";

function PurchaseCategoryPageWrapper() {
  const { purchase, category, setId, clientId } = useParams();

  const decodedCategory = decodeURIComponent(category);

  const renderCategoryPage = () => {
    switch (purchase) {
      case "Category-Purchased":

        if (decodedCategory === "All") {
          return (
            <CategoryDesignPurchasePage
              category="All"
              subCategory="All"
            />
          );
        }
        return <SubCategoryPurchase category={decodedCategory} />;
      case "Collection-Purchased":
        return <CollectionCategoryPurchase collection={decodedCategory} />;

      case "Sets-Purchased":
        return <SetPurchaseDesignPage setName={decodedCategory} />;

      case "Partial-Sets-Purchased":
        return <PartialSetsPurchaseDesignPage setName={decodedCategory} isPartial={true} />;

      default:
        return <div style={{ color: "gray" }}>No matching category component for {purchase}</div>;
    }
  };

  return <>{renderCategoryPage()}</>;
}
export default PurchaseCategoryPageWrapper;
